module.exports = __webpack_public_path__ + "static/media/asterisco.8a0e2a04.svg";